import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { T, useTranslate } from 'shared/helper/translate';
import { FILE_STATUS } from '../constants';
import FileProgress from './FileProgress';
var FileStatus = function FileStatus(_ref) {
  var file = _ref.file,
    progress = _ref.progress,
    removeFile = _ref.removeFile;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  if (file.status === FILE_STATUS.STATUS_UPLOAD_FAILURE) {
    return /*#__PURE__*/React.createElement("span", {
      className: "status-with-text"
    }, /*#__PURE__*/React.createElement("button", {
      "aria-label": t('Remove'),
      type: "button",
      className: "ms-2 text-danger",
      onClick: removeFile
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-xmark"
    })));
  }
  if (file.status === FILE_STATUS.STATUS_FILETYPE_FAILURE) {
    return /*#__PURE__*/React.createElement("span", {
      className: "status-with-text"
    }, /*#__PURE__*/React.createElement(T, {
      source: "Filetype not allowed"
    }), /*#__PURE__*/React.createElement("button", {
      "aria-label": t('Remove'),
      type: "button",
      className: "ms-2 text-danger",
      onClick: removeFile
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-xmark"
    })));
  }
  if (file.status === FILE_STATUS.STATUS_UPLOAD_PROCESSING) {
    return /*#__PURE__*/React.createElement(FileProgress, {
      progress: progress
    });
  }
  return null;
};
export default FileStatus;